import React, { useEffect, useState } from "react";
import { getOrders } from "../../services/getOrders";
import { useUser } from '../../Context/UserContext';
import { addProductToOrder } from "../../services/posOrders"

import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Popover from '@mui/material/Popover';
import { useNavigate } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

function getTotalPrice(price, quantity){
    let totalPrice = 0;
    totalPrice = parseInt(price.slice(1)) * parseInt(quantity);
    totalPrice = "₡" + totalPrice;
    return totalPrice;
}
export default function TransitionsModal(props) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const { user, setUser } = useUser();
  const [orderId, setOrderId] = useState(null);
  
  useEffect(() => {
      const storedUser = localStorage.getItem('user');
      if (storedUser) {
          setUser(JSON.parse(storedUser));
      }
      setIsLoading(false);
  }, [setUser]);

  useEffect(() => {
      if (user?.id) {
          getOrders(user.id).then((result) => {
              if (result.draftOrders.length > 0) {
                  setOrderId(result.draftOrders[0].orderId);
              }
          });
      }
  }, [user]);

  const handleOpen = (event) => {
      if (!user) {
          navigate('/iniciar-sesion');
          return;
      }
      if (props.quantity === 0) {
          setAnchorElPopoverEmpty(event.currentTarget);
      } else {
          setOpen(true);
      }
  };

  const handleClose = () => setOpen(false);

  const totalPrice = getTotalPrice(props.price, props.quantity);

  const [anchorElPopoverEmpty, setAnchorElPopoverEmpty] = React.useState(null);
  const handleClosePopoverEmpty = () => {
    setAnchorElPopoverEmpty(null);
  };

  const openPopoverEmpty = Boolean(anchorElPopoverEmpty);

  const id = openPopoverEmpty ? 'simple-popover' : undefined;

    const handleAddToCart = async () => {
      if (!orderId) {
          alert("No se encontró una orden activa.");
          return;
      }
      //console.log(orderId)
      try {
          await addProductToOrder(orderId, {
              id: props.id,
              qty: props.quantity,
              subprice: parseInt(props.price.slice(1))
          });
          //console.log(parseInt(props.id));
          //console.log(parseInt(props.price.slice(1)));
          //console.log(props.quantity);
          alert("Producto agregado al carrito");
          handleClose();
      } catch (error) {
          alert("Error al agregar producto al carrito");
      }
  };


  return (
    <div>
      <Tooltip title={!user ? "Necesita estar con la sesión iniciada" : ""} arrow>
        <IconButton color="warning" aria-label="add to shopping cart" onClick={handleOpen}>
          <AddShoppingCartIcon />
        </IconButton>
      </Tooltip>
        <Popover
            open={openPopoverEmpty}
            anchorEl={anchorElPopoverEmpty}
            onClose={handleClosePopoverEmpty}
            anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
            }}
        >
            <Typography sx={{ p: 2, fontStyle:'italic'}}>Cantidad sin ingresar</Typography>
        </Popover>
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
            backdrop: {
            timeout: 500,
            },
            }}
        >
            <Fade in={open}>
                <Box sx={style} >
                    <Typography id="transition-modal-title" variant="h6" component="h2" color='#000'>
                        Añadir al carrito de compras
                    </Typography>
                    <div style={{marginTop: '32px', marginLeft:'10px', color: "#000"}}>
                        <div style={{fontWeight:'bold'}}>
                            Producto: {props.product}
                        </div>
                        <div style={{marginLeft:'15px'}}>
                            <div style={{marginTop: '20px'}}>
                                    Cantidad: {props.quantity}
                            </div>
                            <div style={{marginTop: '20px'}}>
                                Precio unitario: {props.price}
                            </div>
                            <div style={{fontWeight:'bold', marginTop: '20px'}}>
                                Total: {totalPrice}
                            </div>
                        </div>
                    </div>
                    <Stack direction="row" spacing={2} style={{marginTop: '40px'}}>
                        <Button variant="outlined" color="error" onClick={handleClose}>
                            Cancelar
                        </Button>
                        <Button variant="contained" color="success" onClick={handleAddToCart}>
                            Agregar al carrito
                        </Button>
                    </Stack>
                </Box>
            </Fade>
        </Modal>
    </div>
  );
}